/* CHROMA & CHORA — theme.js | vanilla, no libraries */
(function () {
  'use strict';

  function lock(on) { document.documentElement.toggleAttribute('data-scroll-lock', on); }
  var closeDrawerRef = null;

  /* Expose header + announce height so full-height sections can match exactly */
  var setChrome = function () {
    var c = 0;
    document.documentElement.style.setProperty('--chrome', c + 'px');
  };
  setChrome();
  window.addEventListener('resize', setChrome);
  window.addEventListener('load', setChrome);

  /* Mega menu — hover + click, Escape closes, focus returns */
  var megaTriggers = [].slice.call(document.querySelectorAll('[data-mega-trigger]'));
  var mega = document.querySelector('[data-mega]');
  if (megaTriggers.length && mega) {
    var t;
    var lastTrigger = megaTriggers[0];
    var setMega = function (open) {
      mega.setAttribute('data-open', open ? 'true' : 'false');
      megaTriggers.forEach(function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
    };
    var close = function (refocus) { setMega(false); if (refocus && lastTrigger) lastTrigger.focus(); };
    megaTriggers.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        lastTrigger = btn;
        if (window.matchMedia('(hover: hover)').matches) return;
        if (mega.getAttribute('data-open') !== 'true') { e.preventDefault(); setMega(true); }
      });
      btn.addEventListener('focus', function () { lastTrigger = btn; });
    });
    megaTriggers.concat([mega]).forEach(function (el) {
      el.addEventListener('mouseenter', function () { clearTimeout(t); if (window.matchMedia('(hover: hover)').matches) setMega(true); });
      el.addEventListener('mouseleave', function () { t = setTimeout(function () { setMega(false); }, 160); });
    });
    document.addEventListener('click', function (e) {
      var inTrigger = megaTriggers.some(function (b) { return b.contains(e.target); });
      if (mega.getAttribute('data-open') === 'true' && !mega.contains(e.target) && !inTrigger) close(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && mega.getAttribute('data-open') === 'true') close(true);
    });
  }

  /* Mobile drawer */
  var burger = document.querySelector('[data-drawer-open]');
  var drawer = document.querySelector('[data-drawer]');
  if (burger && drawer) {
    var closeBtn = drawer.querySelector('[data-drawer-close]');
    var scrim = document.querySelector('[data-drawer-scrim]');
    var setDrawer = function (open) {
      drawer.setAttribute('data-open', open ? 'true' : 'false');
      drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (scrim) scrim.setAttribute('data-open', open ? 'true' : 'false');
      document.documentElement.toggleAttribute('data-menu-open', open);
      lock(open);
      if (open) { var fst = drawer.querySelector('a, button'); if (fst) fst.focus(); } else { burger.focus(); }
    };
    burger.addEventListener('click', function () { setDrawer(true); });
    closeDrawerRef = function () { if (drawer.getAttribute('data-open') === 'true') setDrawer(false); };
    if (closeBtn) closeBtn.addEventListener('click', function () { setDrawer(false); });
    if (scrim) scrim.addEventListener('click', function () { setDrawer(false); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.getAttribute('data-open') === 'true') setDrawer(false);
    });
  }

  /* Search overlay */
  var searchBtns = document.querySelectorAll('[data-search-open]');
  var searchOv = document.querySelector('[data-search]');
  if (searchOv && searchBtns.length) {
    var last = null;
    var setSearch = function (open) {
      if (open && closeDrawerRef) closeDrawerRef();
      searchOv.setAttribute('data-open', open ? 'true' : 'false');
      searchOv.setAttribute('aria-hidden', open ? 'false' : 'true');
      lock(open);
      if (open) { var i = searchOv.querySelector('input'); if (i) i.focus(); } else if (last) { last.focus(); }
    };
    searchBtns.forEach(function (b) { b.addEventListener('click', function () { last = b; setSearch(true); }); });
    var sc = searchOv.querySelector('[data-search-close]');
    if (sc) sc.addEventListener('click', function () { setSearch(false); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && searchOv.getAttribute('data-open') === 'true') setSearch(false);
    });

    /* Live search over the collection index */
    var srIndex = [
      ['Forma lounge chair','Living','Seating'],['Riva sideboard','Living','Storage'],['Halo coffee table','Living','Tables'],['Arco floor lamp','Living','Lighting'],['Pico side table','Living','Tables'],
      ['Chroma dining table','Dining','Tables'],['Ostra dining chair','Dining','Seating'],['Meridian credenza','Dining','Storage'],['Duo candleholders','Dining','Objects'],['Stria serving bowl','Dining','Objects'],
      ['Luna bed head','Bedroom','Objects'],['Column bedside table','Bedroom','Tables'],['Arc wall light','Bedroom','Lighting'],['Softline bench','Bedroom','Seating'],['Terra chest of drawers','Bedroom','Storage'],
      ['Strada console','Entry and Hallway','Tables'],['Orb mirror','Entry and Hallway','Objects'],['Stem coat stand','Entry and Hallway','Objects'],['Plinth stool','Entry and Hallway','Seating'],['Tessel tray','Entry and Hallway','Objects'],
      ['Ledger desk','Study','Tables'],['Curve task chair','Study','Seating'],['Stack shelving','Study','Storage'],['Cone desk lamp','Study','Lighting'],['Align bookends','Study','Objects']
    ];
    var srInput = searchOv.querySelector('#SearchInput');
    var srResults = searchOv.querySelector('[data-sr-results]');
    var srInit = searchOv.querySelector('[data-sr-init]');
    var esc = function (s) { return s.replace(/&/g, '&amp;').replace(/</g, '&lt;'); };
    var srRender = function () {
      var q = (srInput.value || '').trim().toLowerCase();
      if (!q) { srResults.hidden = true; srInit.hidden = false; return; }
      var hits = srIndex.filter(function (it) {
        return (it[0] + ' ' + it[1] + ' ' + it[2]).toLowerCase().indexOf(q) > -1;
      }).slice(0, 8);
      srInit.hidden = true; srResults.hidden = false;
      if (!hits.length) {
        srResults.innerHTML = '<p class="sr-empty">No pieces match \u201C' + esc(srInput.value.trim()) + '\u201D \u2014 try a room or a category.</p>';
        return;
      }
      srResults.innerHTML = hits.map(function (it) {
        return '<a class="sr-row" href="/search?q=' + encodeURIComponent(it[0]) + '"><b>' + esc(it[0]) + '</b><span>' + esc(it[1]) + ' \u00B7 ' + esc(it[2]) + '</span></a>';
      }).join('');
    };
    if (srInput && srResults && srInit) {
      srInput.addEventListener('input', srRender);
      [].slice.call(searchOv.querySelectorAll('[data-sr-chip]')).forEach(function (ch) {
        ch.addEventListener('click', function () { srInput.value = ch.textContent.trim(); srInput.focus(); srRender(); });
      });
    }
  }

  /* Hero carousel */
  var hcar = document.querySelector('[data-hcar]');
  if (hcar) {
    var slides = [].slice.call(hcar.querySelectorAll('.hcar__s'));
    var dotsWrap = hcar.querySelector('[data-hcar-dots]');
    var idx = 0, timer = null;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var dots = slides.map(function (_, i) {
      var b = document.createElement('button');
      b.className = 'hcar__dot'; b.type = 'button';
      b.setAttribute('aria-label', 'Slide ' + (i + 1));
      b.addEventListener('click', function () { go(i); restart(); });
      dotsWrap.appendChild(b);
      return b;
    });
    var go = function (i) {
      idx = (i + slides.length) % slides.length;
      slides.forEach(function (s, j) {
        if (j === idx) { s.setAttribute('data-on', ''); } else { s.removeAttribute('data-on'); }
        s.setAttribute('aria-hidden', j === idx ? 'false' : 'true');
      });
      dots.forEach(function (d, j) { if (j === idx) { d.setAttribute('data-on', ''); } else { d.removeAttribute('data-on'); } });
    };
    var restart = function () {
      if (timer) clearInterval(timer);
      if (!reduced) timer = setInterval(function () { go(idx + 1); }, 8000);
    };
    var prev = hcar.querySelector('[data-hcar-prev]');
    var next = hcar.querySelector('[data-hcar-next]');
    if (prev) prev.addEventListener('click', function () { go(idx - 1); restart(); });
    if (next) next.addEventListener('click', function () { go(idx + 1); restart(); });
    hcar.addEventListener('mouseenter', function () { if (timer) clearInterval(timer); });
    hcar.addEventListener('mouseleave', restart);
    go(0); restart();
  }

  /* Room tabs -> heading word + rail swap */
  var roomTabs = [].slice.call(document.querySelectorAll('[data-tab]'));
  if (roomTabs.length) {
    var rails = [].slice.call(document.querySelectorAll('[data-room-rail]'));
    var arches = [].slice.call(document.querySelectorAll('[data-room-arch]'));
    var word = document.querySelector('[data-room-word]');
    roomTabs.forEach(function (tab) {
      var activate = function () {
        roomTabs.forEach(function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
        rails.forEach(function (r) { r.hidden = r.getAttribute('data-room-rail') !== tab.getAttribute('data-tab'); });
        arches.forEach(function (a) { a.hidden = a.getAttribute('data-room-arch') !== tab.getAttribute('data-tab'); });
        if (word) word.textContent = tab.getAttribute('data-word');
      };
      tab.addEventListener('click', activate);
      tab.addEventListener('mouseenter', activate);
      tab.addEventListener('focus', activate);
    });
  }

  /* Drag-to-scroll rails */
  [].slice.call(document.querySelectorAll('.rail-x')).forEach(function (el) {
    var down = false, sx = 0, sl = 0, moved = false;
    el.addEventListener('pointerdown', function (e) { down = true; moved = false; sx = e.clientX; sl = el.scrollLeft; });
    el.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - sx;
      if (Math.abs(dx) > 6 && !moved) { moved = true; el.setAttribute('data-drag', ''); try { el.setPointerCapture(e.pointerId); } catch (err) {} }
      if (moved) el.scrollLeft = sl - dx;
    });
    var end = function () { down = false; moved = false; el.removeAttribute('data-drag'); };
    el.addEventListener('pointerup', end);
    el.addEventListener('pointercancel', end);
    el.addEventListener('click', function (e) { if (el.hasAttribute('data-drag')) e.preventDefault(); }, true);
  });

  /* Layered scroll reveals — IO plus a rect-check fallback (IO can be throttled in iframes) */
  var rvEls = [].slice.call(document.querySelectorAll('.rv'));
  if (rvEls.length) {
    var rvPending = rvEls.slice();
    var rvShow = function (el) { el.classList.add('in'); };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { rvShow(en.target); io.unobserve(en.target); } });
      }, { threshold: 0.18, rootMargin: '0px 0px -6% 0px' });
      rvEls.forEach(function (el) { io.observe(el); });
    }
    var rvSweep = function () {
      if (!rvPending.length) return;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      rvPending = rvPending.filter(function (el) {
        if (el.classList.contains('in')) return false;
        var r = el.getBoundingClientRect();
        if (r.top < vh * 0.94 && r.bottom > 0) { rvShow(el); return false; }
        return true;
      });
    };
    window.addEventListener('scroll', rvSweep, { passive: true });
    window.addEventListener('resize', rvSweep);
    rvSweep();
    setTimeout(rvSweep, 400);
    setTimeout(function () {
      // last-resort: anything above the fold or in a stuck environment must not stay invisible
      rvPending.forEach(function (el) { var r = el.getBoundingClientRect(); if (r.top < (window.innerHeight || 800) * 1.05) rvShow(el); });
      rvPending = rvPending.filter(function (el) { return !el.classList.contains('in'); });
    }, 1600);
  }

  /* Customisation colourways */
  var cw = document.querySelector('[data-cw]');
  if (cw) {
    var mist = document.querySelector('.mist-sec');
    [].slice.call(cw.querySelectorAll('[data-cw-c]')).forEach(function (b) {
      b.addEventListener('click', function () {
        [].slice.call(cw.querySelectorAll('[data-cw-c]')).forEach(function (o) { o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); });
        if (mist) mist.style.setProperty('--acc', b.getAttribute('data-cw-c'));
      });
    });
  }

  /* Accordions: drawer groups, FAQ, product info */
  document.querySelectorAll('[data-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var panel = document.getElementById(btn.getAttribute('data-toggle'));
      if (!panel) return;
      var open = panel.getAttribute('data-open') === 'true';
      panel.setAttribute('data-open', open ? 'false' : 'true');
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
    });
  });
})();
/* Service-page stale cache safety net. */
/* ccServicePageViewRedirect_iv138709696597r9_cv138709696597r9 */
(function ccNormalizeServicePageViews() {
  'use strict';
  var routes = {
    '/pages/interior-furnishing': '/pages/interior-furnishing?view=iv138709696597r9',
    '/pages/customisation': '/pages/customisation?view=cv138709696597r9'
  };
  var target = routes[window.location.pathname];
  var params = new URLSearchParams(window.location.search);
  if (target && !params.has('view') && !params.has('preview_theme_id')) {
    window.location.replace(target + window.location.hash);
  }
})();
/* End service-page stale cache safety net. */

/* Storefront link safety net for Shopify edge-cached HTML. */
/* ccNormalizeThemeLinks_v138709696597r21_v138709696597r8 */
(function ccNormalizeThemeLinks() {
  'use strict';
  var canonicalHome = '/?view=v138709696597r21';
  var canonicalShop = '/pages/shop?view=v138709696597r8';
  var shopPath = '/pages/' + 'shop';
  var params = new URLSearchParams(window.location.search);
  var activeView = params.get('view') || '';
  if (window.location.pathname === '/' && activeView && ('/?view=' + activeView) !== canonicalHome && !params.has('preview_theme_id')) {
    window.location.replace(canonicalHome + window.location.hash);
    return;
  }
  function normalize() {
    document.querySelectorAll('a[href]').forEach(function (link) {
      var raw = link.getAttribute('href') || '';
      if (raw === '/') {
        link.setAttribute('href', canonicalHome);
        return;
      }
      var parsed;
      try { parsed = new URL(raw, window.location.origin); } catch (error) { return; }
      if (parsed.origin !== window.location.origin || parsed.pathname !== shopPath) return;
      var hash = parsed.hash || '';
      if (hash === '#cat=Lighting') {
        link.hidden = true;
        link.setAttribute('aria-hidden', 'true');
        return;
      }
      if (hash === '#cat=Objects') {
        hash = '#cat=Mirrors%20%26%20Dressing';
        if ((link.textContent || '').trim() === 'Objects') {
          link.textContent = 'Mirrors & Dressing';
        }
      }
      link.setAttribute('href', canonicalShop + hash);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', normalize, { once: true });
  } else {
    normalize();
  }
  window.setTimeout(normalize, 500);
})();
